import { ListItemIcon as MUIListItemIcon, ListItemIconProps as MUIListItemIconProps } from '@mui/material';

export interface ListItemIconProps extends MUIListItemIconProps {}

export const ListItemIcon = MUIListItemIcon;
